{
  "home": {
    "title": "Home",
    "welcome": "Welcome to MVL Creative OS",
    "subtitle": "Click an app in the dock below to get started"
  },
  "portfolio": {
    "title": "Portfolio",
    "subtitle": "My work in action",
    "filter": "Filter",
    "categories": {
      "all": "All",
      "video": "Video",
      "apps": "Apps",
      "ux": "UX"
    },
    "backToGrid": "Back to portfolio",
    "aboutProject": "About this project"
  },
  "expertise": {
    "title": "Expertise",
    "subtitle": "My domains",
    "domains": {
      "design": "Design & UX",
      "ai": "AI & Creation",
      "tech": "Technology & Development",
      "strategy": "Strategy & Concept"
    }
  },
  "process": {
    "title": "Process",
    "subtitle": "My workflow in 5 phases"
  },
  "about": {
    "title": "About Me",
    "subtitle": "My story",
    "intro": "Hi, I'm Mick",
    "tagline": "I translate complex questions into elegant solutions",
    "translation": {
      "title": "The Translation",
      "question": "how do I make the complex simple?"
    },
    "pillars": {
      "title": "Three Pillars, One Approach",
      "aiVideo": {
        "title": "AI Video Generation",
        "description": "Creative storytelling with AI"
      },
      "vibeCoding": {
        "title": "Vibe Coding",
        "description": "AI-powered rapid prototyping"
      },
      "uxThinking": {
        "title": "UX Thinking",
        "description": "User experience as foundation"
      }
    },
    "howTheyWork": {
      "title": "How They Work Together",
      "discover": "Discover",
      "prototype": "Prototype",
      "tell": "Tell"
    }
  },
  "contact": {
    "title": "Contact",
    "subtitle": "Let's have a conversation",
    "form": {
      "name": "Name",
      "email": "Email",
      "message": "Message",
      "send": "Send"
    }
  },
  "settings": {
    "title": "Settings",
    "subtitle": "Personalize your experience",
    "theme": {
      "title": "Theme",
      "dark": "Dark",
      "light": "Light",
      "neon": "Neon",
      "highContrast": "High Contrast"
    },
    "background": {
      "title": "Background",
      "subtitle": "Choose a gradient for light theme"
    },
    "language": {
      "title": "Language / Taal",
      "dutch": "Nederlands",
      "english": "English"
    },
    "about": {
      "title": "About MVL Creative OS",
      "version": "Version",
      "description": "A macOS-inspired portfolio operating system built with React, TypeScript and Tailwind CSS."
    }
  }
}